import { SetPostUpdateStatus } from './thunk/setPostUpdateStatus';
import {SetGetWithdrawalsAwaiting} from './thunk/setGetWithdrawalsAwaiting';

export const Thunks = {
    SetGetWithdrawalsAwaiting,
    SetPostUpdateStatus
}